<template>
  <div
    id="titleWheel"
    class="canvas"
    :class="isMobile ? 'canvas-title-mb' : 'canvas-title-pc'"
  >
    <Loading v-if="isLoading"/>
  </div>
</template>

<script>

import Loading from './loading.vue';

export default {
    name: 'TitleWheel',
    components: {
        Loading
    },
    data() {
        return {
            isLoading: false
        };
    },
    props: {
        isMobile: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        setTimeout(() => {
            this.drawPixi();
        }, 1000);
    },
    methods: {
        startTrailer() {
            if (this.screen.state.hasAnimation('animation')) {
                this.screen.state.setAnimation(0, 'animation', true);
            }
        },
        async drawPixi() {
            this.isLoading = true;
            // eslint-disable-next-line import/no-extraneous-dependencies
            const SPINE = await import('pixi-spine');
            const app = new global.PIXI.Application({
                width: 540,
                height: this.isMobile ? 'auto' : 360,
                antialias: true,
                transparent: true,
                powerPreference: 'high-performance',
                resolution: window.devicePixelRatio || 1,
                autoDensity: true
            });
            app.loader
                .add('anim', `/assets/animation/worldcup/title-wheel/${this.isMobile ? 'mobile' : 'desktop'}/sprites_title.json`)
                .load((loader, resources) => {
                    const screen = new SPINE.Spine(resources.anim.spineData);
                    screen.x = app.screen.width / 2;
                    screen.y = this.isMobile ? 220 : 250;
                    screen.scale.set(this.calculateRatio());
                    app.stage.addChild(screen);
                    this.screen = screen;
                    this.startTrailer();
                    app.start();
                    this.isLoading = false;
                });
            this.$el.appendChild(app.view);
            app.renderer.autoResize = true;
            app.renderer.plugins.interaction.autoPreventDefault = false;
            app.renderer.view.style['touch-action'] = 'auto';
            const width = this.isMobile ? 300 : app.view.parentNode.clientWidth;
            app.renderer.resize(width, this.isMobile ? 280 : 300);
        },
        calculateRatio() {
            // eslint-disable-next-line no-nested-ternary
            let scaleData = 0;
            if (this.isMobile) {
                scaleData = 0.58;
            } else {
                scaleData = 0.86;
            }
            return scaleData;
        }
    }
};
</script>

<style scoped lang="scss">
.canvas-title {
  &-pc {
    height: 300px;
    position: relative;
    left: 21px;

  }
  &-mb {
    padding-top: 15px;
    width: 100%;
    text-align: center;
    @media screen and (max-width: 576px) {
      padding-top: 0;
      margin-top: -35px;
    }
  }

  &-kickoff {
    ::v-deep canvas {
      position: relative !important;
    }
  }
}
</style>
